
<template>
  <div>
    <v-menu ref="menu" :disabled="disabled" v-model="dialog_set_date" :close-on-content-click="false" :return-value.sync="date_local" transition="scale-transition" >
      <template v-slot:activator="{ on, attrs }">
        <v-chip v-on="on" style="border-radius: 8px;" >
          <v-avatar left>
            <v-icon>mdi-calendar</v-icon>
          </v-avatar>
          {{$moment(date_local).locale('pt-BR').format('MMM, YYYY')}}
        </v-chip>
      </template>
      <v-date-picker v-model="date_local" :type="kind" :min="min" :max='max' scrollable locale="pt-BR" color="primary" >
        <v-btn text small color="error" @click="dialog_set_date = false" >
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn text small color="primary" @click="$refs.menu.save(date_local)" >
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'ChipMonthPickerMenu',
  
  props: {
    value: {
      type: String,
      default: ''
    },
    kind:{
      type: String,
      default: 'date',
    },
    min:{
      type: String,
      default: null,
    },
    max:{
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      dialog_set_date: false,
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    date_local: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", `${value}`);
      }
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      }
    }
  },
}
</script>

<style scoped>

</style>